import React, { useEffect, useState } from "react";
import LinkedinSelectedReactionIcon from "./LinkedinSelectedReactionIcon";

const LinkedinSelectedReactions = ({ comments, reactions }) => {
  const [reactionsIcons, setReactionsIcons] = useState();
  const [commentsCount, setCommentsCount] = useState(0);

  useEffect(
    () => {
      const uniqueReactions = reactions?.filter(
        (reaction, index, self) => index === self.findIndex(t => (
          t.reactionType === reaction.reactionType
        ))
      );
      setReactionsIcons(uniqueReactions);
    },
    [reactions]
  );

  useEffect(
    () => {
      if (comments) {
        setCommentsCount(comments.reduce(
          ((partialSum, comment) => partialSum + 1
            + (comment?.commentsSummary?.aggregatedTotalComments || 0)), 0
        ));
      }
    },
    [comments]
  );

  return (
    <div className="Interactions-Container__Reactions">
      {reactionsIcons?.map(reaction => (
        <LinkedinSelectedReactionIcon
          key={reaction.id || reaction.lastModified.time}
          reaction={reaction}
        />
      ))}
      {reactions?.length > 0 && <span className="Reactions__Count">{reactions.length}</span>}
      {comments && <span className="Comments__Count">{`${commentsCount} comment${commentsCount === 1 ? "" : "s"}`}</span>}
    </div>
  );
};

export default LinkedinSelectedReactions;
